import { render, staticRenderFns } from "./IconBubble.vue?vue&type=template&id=4961af7a"
import script from "./IconBubble.vue?vue&type=script&lang=ts"
export * from "./IconBubble.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports